import $ from 'jquery';
window.$ = $;
window.jQuery = $;
globalThis.$ = globalThis.jQuery = $;
require('bootstrap-sass/assets/javascripts/bootstrap/modal');

var menu = require('./menu');

window.shared = {
    $document: null,
    $body: null,

    init: function() {
        this.$document = $(document);
        this.$body = $('body');

        menu.init();
    }
};